import { createAction, props } from '@ngrx/store';
export const setFundChartLineAnnotations = createAction('[Fund Chart] Set line annotations', props());
export const setFundChartLineAnnotation = createAction('[Fund Chart] Set line annotation', props());
export const removeFundChartLineAnnotation = createAction('[Fund Chart] Remove line annotation', props());
